import React from 'react';


export const MenuContext = React.createContext({
    active: false,
    toggleActive: () => { console.log('Toggle Theme Called') },
});